import React from "react";
import TextField from "@mui/material/TextField";

const PhoneInput = ({ label, value, onChange, disabled = false }) => {
    const handleInputChange = (e) => {
        // Remova caracteres não numéricos e aplique a máscara
        const rawValue = e.target.value.replace(/\D/g, ""); // Remove tudo que não for número
        const formattedValue = rawValue
            .replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3") // Formato completo com DDD
            .replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3") // Para números menores
            .slice(0, 15); // Limita o tamanho final
        onChange({ target: { value: formattedValue } });
    };

    return (
        <TextField
            label={label}
            value={value}
            onChange={handleInputChange}
            disabled={disabled}
            fullWidth
            variant="outlined"
            inputProps={{
                maxLength: 15, // Limite de caracteres com máscara
            }}
            inputMode="numeric"
        />
    );
};

export default PhoneInput;
